// extracted by mini-css-extract-plugin
module.exports = {"uploaderWrapper":"DocumentField_uploaderWrapper__1gSf5"};